import script from "./upsell-compact-slide.vue?vue&type=script&setup=true&lang=js"
export * from "./upsell-compact-slide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__